import { render, staticRenderFns } from "./Panel_agentes.vue?vue&type=template&id=0a0839e4&"
import script from "./Panel_agentes.vue?vue&type=script&lang=js&"
export * from "./Panel_agentes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports